/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
// import "core-js/stable";
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import sampleData from './sampleData'
import Toast, { TYPE } from 'vue-toastification'

window.Vue = require('vue').default

Vue.component('app-header', () => import('./components/Header'))
Vue.component('app-slideshow-services', () => import('./components/SliderServices'))
Vue.component('app-slideshow-testimonials', () => import('./components/SliderTestimonials'))
Vue.component('app-slideshow-service-gallery', () => import('./components/SliderServiceGallery'))
Vue.component('app-our-people', () => import('./components/OurPeople'))
Vue.component('app-gallery', () => import('./components/GalleryArea'))
Vue.component('app-container-unpacking', () => import('./components/ContainerUnpacking'))
Vue.component('app-container-import', () => import('./components/ContainerImport'))

Vue.component('app-map', () => import('./components/Map'))
Vue.component('nav-accordion', () => import('./components/NavAccordion'))
Vue.component('app-carousel', () => import('./components/Carousel'))

const toastOptions = {
  containerClassName: 'ryders-toast-wrap',
  toastClassName: 'ryders-toast',
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  closeButton: 'button',
  closeButtonClassName: 'custom-close',
  hideProgressBar: true,
  toastDefaults: {
    // ToastOptions object for each type of toast
    [TYPE.ERROR]: {
      timeout: 10000,
    },
    [TYPE.SUCCESS]: {
      timeout: 0,
      icon: {
        iconClass: 'material-icons',
        iconChildren: 'check_circle',
        iconTag: 'span',
      },
    },
  },
}

Vue.use(Toast, toastOptions)

new Vue({
  data: () => ({
    isLoaded: false,
    tab: 'east',
    faq: null,
    menu: [
      { url: '/pet-records', title: 'Pet Records' },
      { url: '/medicinal-refill', title: 'Medicinal Re-fill' },
      { url: '/services', title: 'Services' },
      { url: '/blog', title: 'Clinic News' },
      { url: '/contact', title: 'Contact Us' },
      { url: '/shop', title: 'Shop' },
      { url: '/about', title: 'About' },
      { url: '/gallery', title: 'Gallery' },
      { url: '/our-people', title: 'Our People' },
    ],
    samplePeople: sampleData.people,
    sortColumn1: false,
    contactCustomSelectOpen: false,
    reqQuoteCustomSelectOpen: false,
  }),

  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == 'complete') {
        this.isLoaded = true
      }
    }

    if (window.location.href.indexOf('quote-submitted') != -1) {
      this.showToast()
    }
  },

  methods: {
    toggleTab(tab) {
      this.tab = tab
    },

    toggleFAQ(index) {
      if (index === this.faq) {
        this.faq = null
      } else {
        this.faq = index
      }
    },

    showToast() {
      this.$toast.success('Form submitted')
    },

    toggleSortColumn1() {
      this.sortColumn1 = !this.sortColumn1
    },

    toggleContactCustomSelect() {
      this.contactCustomSelectOpen = !this.contactCustomSelectOpen
    },
    selectItem(item) {
      document.getElementById('service_display').innerHTML = item
      document.getElementById('service').value = item
      this.contactCustomSelectOpen = !this.contactCustomSelectOpen
    },

    toggleReqQuoteCustomSelect() {
      this.reqQuoteCustomSelectOpen = !this.reqQuoteCustomSelectOpen
    },
    selectCargoItem(item) {
      document.getElementById('service_display').innerHTML = item
      document.getElementById('cargo-type').value = item
      this.reqQuoteCustomSelectOpen = !this.reqQuoteCustomSelectOpen
    },
  },
}).$mount('#app')
